// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:20+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            aed460924112c39906e0865e5759f7d8
//    Signature:      eyJpdiI6ImxwSnpubUxtT0l1WG1MMCtZY2ZiTWc9PSIsInZhbHVlIjoiS0p1NUszYmRPbGxnNFQ2VEFmOSt3Y3hIWGJITXhGZDlHajFLbGFqZnZXVHA5bnZ1Z010VklzbzRJRGI1eUh6blMyMVJqbXNQRjU1S3NEaU5DT0tMbVh4OWl3NlZRbWdmMVM0YVZhSVlsZDdWMkF5eWU0YjhHdTdkdFRWcU9lcUcwRG51K0JiVkM1MmRGTStKSzhCMlp5TWRSWGxNOVpTcWNRV2RcL2VsUDQzNnU3eEV0Rm9sbkNUM0xUU1lYcFVXM0JBdTIxWlc2NExOcFpVRFI0Q0kzOWFpN0llNndnMGQyZGd4TVlMUG9wR3Z1U1l1eXJsdGNpM1owZVp4VmlUd2wwd0dZZHphc3R6V1k4VmRnclREMWhZblZkWDJZVG5vaGdFOFBKb1pSbjY1T3hhc0QzSGdjc2drT3plemo1bEZOeVUxZXM5a3lubnUxbFUzYmpqRGJFMHgzSDNWSTlYUE9DUUVHWnprUEpZUW1QQit3cjFHOEJCb1JsMk95ak1seUZONSs0ZVVnXC9xVW9veG52bUVWN1Nza0tTc1oxUTVrZU8yVnpaR1M5aUJrPSIsIm1hYyI6IjJmODA3ZjVhZTdmNmVjNTljNDMzYzZkYTllMTEzZmMwMjkxNWI5N2YwNzM3ZDkwOGEzZTJiOWQ1Y2NhNjc0MzIifQ==
((document, window) => {
    const okeRenderedHandler = function (e) {
        if (e.detail.widget === 'reviews-widget') {
            setupCollectionDropdownControls();
        }
    }

    document.addEventListener('oke-rendered', okeRenderedHandler);

    if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
            value: function (search, rawPos) {
                var pos = rawPos > 0 ? rawPos | 0 : 0;
                return this.substring(pos, pos + search.length) === search;
            }
        });
    }

    function i(e, t) {
        var n;
        if ('undefined' == typeof Symbol || null == e[Symbol.iterator]) {
            if (
                Array.isArray(e) ||
                (n = (function (e, t) {
                    if (!e) return;
                    if ('string' == typeof e) return o(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    'Object' === n && e.constructor && (n = e.constructor.name);
                    if ('Map' === n || 'Set' === n) return Array.from(e);
                    if ('Arguments' === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
                })(e)) ||
                (t && e && 'number' == typeof e.length)
            ) {
                n && (e = n);
                var i = 0,
                    r = function () { };
                return {
                    s: r,
                    n: function () {
                        return i >= e.length ? { done: !0 } : { done: !1, value: e[i++] };
                    },
                    e: function (e) {
                        throw e;
                    },
                    f: r,
                };
            }
            throw new TypeError('Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.');
        }
        var a,
            s = !0,
            c = !1;
        return {
            s: function () {
                n = e[Symbol.iterator]();
            },
            n: function () {
                var e = n.next();
                return (s = e.done), e;
            },
            e: function (e) {
                (c = !0), (a = e);
            },
            f: function () {
                try {
                    s || null == n.return || n.return();
                } finally {
                    if (c) throw a;
                }
            },
        };
    }

    function toggleVisibility(e) {
        var t,
            n = i(e);
        try {
            for (n.s(); !(t = n.n()).done;) {
                t.value.classList.toggle('is-visible');
            }
        } catch (e) {
            n.e(e);
        } finally {
            n.f();
        }
    }

    function setupCollectionDropdownControls() {
        var navbarMale = document.querySelector('.orc-radioControl-navbar-item.js-orc--male');
        var navbarFemale = document.querySelector('.orc-radioControl-navbar-item.js-orc--female');
        var maleSelectList = document.querySelector('.orc-collectionControls-item--male');
        var femaleSelectList = document.querySelector('.orc-collectionControls-item--female');
        var reviewsWidgetElement = document.querySelector('#orc-widget-snippet');

        attachNavbarClickEvents(navbarMale, maleSelectList, navbarFemale, femaleSelectList, reviewsWidgetElement);

        var femaleCollectionDropdownList = document.querySelector('.js-orc-collectionDropdown.js-orc--female');
        document.querySelectorAll('.orc-collectionControls-item--female .orc-collectionDropdown-item'),
            femaleCollectionDropdownList.addEventListener('click', function () {
                toggleVisibility(femaleCollectionDropdownListItems), femaleCollectionDropdownList.classList.toggle('active');
            });
        
        var maleCollectionDropdownList = document.querySelector('.js-orc-collectionDropdown.js-orc--male');
        var maleCollectionDropdownListItem = document.querySelectorAll('.orc-collectionControls-item--male .orc-collectionDropdown-item');
        
        maleCollectionDropdownList.addEventListener('click', function () {
            toggleVisibility(maleCollectionDropdownListItem), maleCollectionDropdownList.classList.toggle('active');
        });

        var u,
            femaleCollectionDropdownListItems = Array.prototype.slice.call(document.querySelectorAll('.orc-collectionControls-item--female .orc-collectionDropdown-item')),
            h = i(femaleCollectionDropdownListItems);
        try {
            var f = function () {
                var e = u.value;
                e.addEventListener('click', function () {
                    if (!e.getAttribute('value')) {
                        snippetEl.removeAttribute('data-oke-reviews-group-id');
                        snippetEl.removeAttribute('data-oke-reviews-product-id');
                        snippetEl.innerHTML = '';
                        window.okeWidgetApi.initWidget(snippetEl, true);
                        return;
                    }

                    window.okeWidgetApi.setGroup(reviewsWidgetElement, e.getAttribute('value'));

                    toggleVisibility(femaleCollectionDropdownListItems);
                    (femaleCollectionDropdownList.innerHTML = e.innerHTML);
                    femaleCollectionDropdownList.setAttribute('data-displayed', e.innerHTML);
                    if (femaleCollectionDropdownList.classList.contains('active')) {
                        femaleCollectionDropdownList.classList.remove('active');
                    }
                });
            };
            for (h.s(); !(u = h.n()).done;) f();
        } catch (e) {
            h.e(e);
        } finally {
            h.f();
        }
        var m,
            p = Array.prototype.slice.call(document.querySelectorAll('.orc-collectionControls-item--male .orc-collectionDropdown-item')),
            v = i(p);
        try {
            var y = function () {
                var e = m.value;
                e.addEventListener('click', function () {
                    if (!e.getAttribute('value')) {
                        snippetEl.removeAttribute('data-oke-reviews-group-id');
                        snippetEl.removeAttribute('data-oke-reviews-product-id');
                        snippetEl.innerHTML = '';
                        window.okeWidgetApi.initWidget(snippetEl, true);
                        return;
                    }

                    window.okeWidgetApi.setGroup(reviewsWidgetElement, e.getAttribute('value'))
                    toggleVisibility(p);
                    (maleCollectionDropdownList.innerHTML = e.innerHTML);
                    maleCollectionDropdownList.setAttribute('data-displayed', e.innerHTML);

                    if (maleCollectionDropdownList.classList.contains('active')) {
                        maleCollectionDropdownList.classList.remove('active');
                    }
                });
            };
            for (v.s(); !(m = v.n()).done;) y();
        } catch (e) {
            v.e(e);
        } finally {
            v.f();
        }

        document.removeEventListener('oke-rendered', okeRenderedHandler);
    }

    function attachNavbarClickEvents(navbarMale, maleSelectList, navbarFemale, femaleSelectList, reviewsWidgetElement) {
        navbarMale.addEventListener('click', function () {
            (navbarMale.classList.contains('is-active') && !t.classList.contains('is-active')) ||
                (navbarMale.classList.toggle('is-active'),
                    maleSelectList.classList.toggle('is-active'),
                    navbarFemale.classList.remove('is-active'),
                    femaleSelectList.classList.remove('is-active'),
                    navbarMale.classList.contains('is-active') && window.okeWidgetApi.setGroup(reviewsWidgetElement, 'a5a04748-c618-46c0-bbfa-45c922a23215'));
        });

        navbarFemale.addEventListener('click', function () {
            (navbarFemale.classList.contains('is-active') && !navbarMale.classList.contains('is-active')) ||
                (navbarFemale.classList.toggle('is-active'),
                    femaleSelectList.classList.toggle('is-active'),
                    navbarMale.classList.remove('is-active'),
                    maleSelectList.classList.remove('is-active'),
                    navbarFemale.classList.contains('is-active') && window.okeWidgetApi.setGroup(reviewsWidgetElement, 'b38aa450-ab71-4233-a611-ca17a66a3bc5'));
        });
    }
})(document, window);